<template>
  <report-section title="鼾声统计" style="position: relative">
    <template v-slot:content>
      <div class="heart-statistics">
        <data-abstract-unit
          title="鼾声事件次数"
          :value="model.snoringBeCnt"
        ></data-abstract-unit>
        <data-abstract-unit
          title="平均每次打鼾声音"
          :value="model.snoringBeMeanLen"
        ></data-abstract-unit>
        <data-abstract-unit
          title="总共打鼾时间"
          :value="model.snoringBeTotalTime"
        ></data-abstract-unit>


      </div>
    </template>
  </report-section>
</template>



<script>
import DataAbstractUnit from "@c/m11b-report-detail/data-abstract/data-abstract-unit.vue";
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
export default {
  components: {
    DataAbstractUnit,
    ReportSection,
  },

  props: {
    model: Object,
  },
};
</script>

<style lang="scss" scoped>

.heart-statistics {
  width: 100%;
  box-sizing: border-box;
  padding: rem(20) rem(20);
  display: flex;
  justify-content: space-between;
}
</style>